import http from "../../utils/http";



//  내가 매니징하는 회사 목록 조회
export const getCareCompanies = (companyIdx, type) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}/care`, {
        params: {
          type
        }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//  내가 매니징하는 회사 목록 조회
export const getCareCompanyList = (companyIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${companyIdx}/care/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
//  내가 속한 회사가 매니징하는 회사 목록 조회
export const getAllCareCompanies = (companyIdx, type) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}/care/all`, {
        params: {
          type
        }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


//  내가 매니징하는 회사 조회 상세
export const getCareCompany = (companyIdx, type, taregetCompanyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}/care/${taregetCompanyIdx}`, {
        params: {
          type
        }
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 코드 조회
export const getCompaniesCode = (params) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/code`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록된 회사 목록 조회
export const getCompanies = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 엑셀 다운로드
export const getCompaniesExcelDownload = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/excel/download`, params, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록요청 회사 목록 조회
export const getRequestCompanies = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/request/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록요청 회사 승인
export const companyApproved = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}/state`, {
        state: 1
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록요청 회사 거절
export const companyDenied = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}/state`, {
        state: 0
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록 회사 일시중지
export const companyPause = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}/state`, {
        state: 2
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



/**
 * 수임정보 수정 (회사 매니저 정보 수정)
 * @param {*} managerCompanyIdx // managerCompanyIdx 수임 회사
 * @param {*} companyIdx // companyIdx 고객 회사
 * @param {*} params // 
 * { fileIdxes, startTime, endTime, meno}
 * @returns 
 */

export const editCompanyManagerInfo = (managerCompanyIdx, companyIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${managerCompanyIdx}/care/${companyIdx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



/**
 * 
 * @param {*} managerCompanyIdx // managerCompanyIdx 수임 회사
 * @param {*} companyIdx // companyIdx 고객 회사
 * @param {*} params 
 * @returns 
 */
export const addCompanyManagerSchedule = (managerCompanyIdx, companyIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${managerCompanyIdx}/schedule/${companyIdx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



export const getCompanyManagerSchedules = (managerCompanyIdx, companyIdx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${managerCompanyIdx}/schedule/list`, { companyIdx, ...params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifyCompanyManagerSchedule = (managerCompanyIdx, companyIdx, idx, params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${managerCompanyIdx}/schedule/${companyIdx}/${idx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const removeCompanyManagerSchedule = (managerCompanyIdx, companyIdx, idx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/${managerCompanyIdx}/schedule/${companyIdx}/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// ------------------------------------------ //
// 추가 사이트정보 관리

export const addCompanyAddSiteInfo = (managerCompanyIdx, companyIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${managerCompanyIdx}/addsiteinfo/${companyIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanyAddSiteInfos = (managerCompanyIdx, companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${managerCompanyIdx}/addsiteinfo/${companyIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanyAddSiteInfo = (managerCompanyIdx, companyIdx, postIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${managerCompanyIdx}/addsiteinfo/${companyIdx}/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editCompanyAddSiteInfo = (managerCompanyIdx, companyIdx, postIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${managerCompanyIdx}/addsiteinfo/${companyIdx}/${postIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteCompanyAddSiteInfo = (managerCompanyIdx, companyIdx, postIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/${managerCompanyIdx}/addsiteinfo/${companyIdx}/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ------------------------------------------ //
// 담당자 정보 관리

export const addCompanyPersonInCharge = (managerCompanyIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/companies/${managerCompanyIdx}/personincharge`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanyPersonInChargeList = (managerCompanyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${managerCompanyIdx}/personincharge`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editCompanyPersonInCharge = (managerCompanyIdx, postIdx, body = {}) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${managerCompanyIdx}/personincharge/${postIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteCompanyPersonInCharge = (managerCompanyIdx, postIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/${managerCompanyIdx}/personincharge/${postIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const setPuaseCompanyWithTaxCompany = (taxCompanyIdx, companyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${taxCompanyIdx}/pause/${companyIdx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 파트너 가입 / 해지
export const updatePartner = (params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/partner`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
